export default __webpack_public_path__ + "static/media/Freya 9781846161926.38ce57fc.jpg";